// eslint-disable-next-line import/prefer-default-export
export const UPDATE_USER_INFO = 'update_user_info'
export const SET_BUCKET_DOMAIN = 'SET_BUCKET_DOMAIN'
export const SET_BUCKET_DOMAIN_TOKEN = 'SET_BUCKET_DOMAIN_TOKEN'
export const SET_REGION_DATA = 'SET_REGION_DATA'
export const SET_REGION_CITY = 'SET_REGION_CITY'
export const SET_KEEP_ALIVE = 'SET_KEEP_ALIVE'
